export default "__VITE_ASSET__997c42d4__"